module.exports = __webpack_public_path__ + "img/dried-river-feature-img-4.d46ad810.webp";